module.exports = __webpack_public_path__ + "static/media/hen_01.d86878aa.gif";